<template>
  <div>
    <el-dialog
        :visible.sync="viewDialogVisible"
        :show-close="false"
        :modal-append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="800px"
        class="return-detail"
    >
      <div slot="title" class="dialog-title dialog-top">
        <div class="dialog-detail">
          <span class="detail">{{ $lang('批量退回申请') }}</span>
        </div>
        <img class="dialog-close" src="@/assets/images/close.png" alt="" @click="viewDialogVisible = false"/>
      </div>
      <div style="padding-left: 20px" class="dialog-center" v-if="stepIndex === 1">
        <h3>{{ $t('运单号') }}：</h3>
        <div style="height: 240px; overflow: auto">
          <div style="margin-left: 15px; margin-top: 10px" v-for="(item, idx) in tableData" :key="idx">{{ item.waybillNo }}</div>
        </div>
        <p>{{ $t('以上运单可进行退回申请，是否继续？') }}</p>
      </div>
      <div class="dialog-center" v-if="stepIndex === 2">
        <div class="search-form">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="right" label-width="120px">
            <el-form-item style="margin: 30px 0" :label="$lang('退回地址')" prop="userSender">
              <el-input :placeholder="$lang('请选择寄件人信息')" readonly :value="ruleForm.userSender" style="width: 512px !important">
                <template slot="suffix">
                  <i class="iconfont icondizhibao pointer" @click="open(1)"></i>
                </template>
              </el-input>
            </el-form-item>

            <el-table height="250" ref="singleTable" :data="tableData" border style="width: 100%">
              <el-table-column type="index" width="50" :label="$t('序号')"></el-table-column>
              <el-table-column property="waybillNo" :label="$t('运单号')" width="200"></el-table-column>
              <el-table-column property="rebackTransferReason" :label="$t('退回申请原因（手动填写）')">
                <template slot-scope="scope">
                  <el-input style="width: 100%" v-model="scope.row.rebackTransferReason" :placeholder="$t('请输入内容')"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button type="primary" :loading="keyBtn" @click="stepIndex = 2" class="h40" v-if="stepIndex === 1">{{ $lang('申请退回') }}</el-button>
        <el-button type="primary" :loading="keyBtn" @click="sumbit('ruleForm')" class="h40" v-if="stepIndex === 2">{{ $lang('提交申请') }}</el-button>
        <el-button @click="viewDialogVisible = false" class="h40">{{ $lang('取消') }}</el-button>
      </div>
    </el-dialog>
    <AddressBook v-model="addrBook" :selectType="3" @single-row-select="singleRowSelect" ref="address"></AddressBook>
  </div>
</template>
<script>
import AddressBook from '../../place-order/single-order/AddressBook.vue'
import { rebackExpressBatchApply, getDefaultAddress } from '@/api/module/customer'
import { RESPONSE_SUCCESS } from '@constants'

export default {
  name: 'Detail',
  props: {
    waybillNos: {
      type: Array,
      default: _ => [],
    },
  },
  components: {
    AddressBook,
  },
  data() {
    return {
      viewDialogVisible: false,
      stepIndex: 1,
      keyBtn: false,
      idError: false,
      addrBook: false,
      rules: {
        userSender: [
          { required: true, message: this.$t('请选择退回地址'), trigger: ['change', 'blur'] },
        ],
        desc: [
          { required: true, message: this.$t('请填写退回申请原因'), trigger: 'blur' },
        ],
      },
      ruleForm: {
        userSender: ''
      },
      tableData: [],
    }
  },
  computed: {
    countryId() {
      return this.$store.state.base.user.countryId || ''
    }
  },
  watch: {
    waybillNos: {},
  },
  methods: {
    showDialog(data) {
      this.getDefaultAddress()
      this.viewDialogVisible = true
      this.stepIndex = 1
      this.tableData = data.map(waybillNo => {
        return {
          waybillNo: waybillNo,
          rebackTransferReason: '',
          returnAddressId: ''
        }
      })
      console.log(this.tableData)
    },
    hideDialog() {
      this.viewDialogVisible = false
    },
    // 打开地址
    open(selectType) {
      this.addrBook = true
      this.$refs.address.updateBtnStauts(this.userInfo)
    },
    // 获取默认地址
    async getDefaultAddress() {
      const param = {
        type: 3,
      }
      const { code, msg, data } = await getDefaultAddress(param)
      if (code === RESPONSE_SUCCESS) {
        this.$nextTick(() => {
          if (data) {
            this.userInfo = data || ''
            this.ruleForm.userSender = `${data.name}/${data.mobile}/${data.provinceName}${data.cityName}${this.countryId === 1 && data.areaName ? data.areaName : ''}${data.street || ''}${data.detailedAddress}`
          }
        })
      } else {
        this.$message.error(msg)
      }
    },
    singleRowSelect(data, type) {
      console.log('data', data)
      this.userInfo = data
      this.ruleForm.userSender = `${data.name}/${data.mobile}/${data.provinceName}${data.cityName}${this.countryId === 1 && data.areaName ? data.areaName : ''}${data.street || ''}${data.detailedAddress}`
    },
    sumbit(formName) {
      console.log(this.tableData)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let flag = false
          this.tableData.forEach(item => {
            item.returnAddressId = this.userInfo.id
            if (item.rebackTransferReason === '') flag = true
          })
          if (flag) {
            this.$message.error(this.$t('请填写对应退件申请原因'))
            return
          }
          try {
            const res = await rebackExpressBatchApply(this.tableData)
            if (res && res.succ) {
              this.hideDialog()
              if (res && res.data) this.$emit('submit-return', res.data)
            } else {
              this.$message.error(res.msg)
            }
          } catch (error) {
            console.log(error)
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    searchChange() {
      this.idError = !this.idError
    },
    resetSearch() {

    },
  },
}
</script>
<style lang="scss" scoped>
.dialog-top {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .dialog-detail {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .detail {
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFangSC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 16px;
      font-weight: 600;
    }

    i {
      display: inline-block;
      border-radius: 50%;
      overflow: hidden;
      width: 8px;
      height: 8px;
      background: #fa8b14;
      margin-left: 16px;
      margin-right: 8px;
    }
  }

  .dialog-close {
    width: 16px;
    height: 16px;
    display: inline-block;
    cursor: pointer;
  }
}

.dialog-center {
  padding-right: 25px;
  height: 300px;
}

.search-form {
  ::v-deep .el-table {
    .el-input {
      width: 100% !important;
    }
  }
}
</style>
<style lang="scss">
.el-dialog__wrapper.return-detail {
  .el-dialog {
    margin-bottom: 0 !important;

    .el-dialog__body {
      max-height: 600px;
      overflow: auto;
    }
  }

  .el-dialog__footer {
    padding: 0;
    margin: 10px 20px 20px;
  }
}
</style>
